// Project versioning: the trail row a waste change carries. The trail is a display-only
// log — summary + optional entity label, shown on the history page. It is NOT state: a revision's
// waste rows live in project_waste_mapping itself, scoped by revision_id, so nothing folds trail
// snapshots back into reads any more and the full-state snapshot payloads this file used to build
// are gone with them.

export interface WasteVersionDescriptor {
  projectId: string;
  operation: "create" | "update" | "delete";
  summary: string;
  entityId?: string | null;
  entityLabel?: string | null;
}

/**
 * The projectVersion_insert_input for a waste change. created_by / tenant_id / source are
 * stamped server-side via permission presets; the row travels in the same mutation document as
 * the change it describes (see UpsertProjectWasteMappingWithVersionMutation).
 */
export const buildWasteVersionInput = ({ projectId, operation, summary, entityId, entityLabel }: WasteVersionDescriptor) => ({
  projectId,
  entityType: "waste",
  operation,
  summary,
  entityId: entityId ?? null,
  entityLabel: entityLabel ?? null,
  changes: [],
});
